import { StateProvider } from '@uirouter/angularjs';

export const APP_SHELL_STATE = "app_shell_state";
export function configureAppShell($stateProvider: StateProvider) {
    $stateProvider.state(APP_SHELL_STATE, {
        abstract: true,
        views: {
            "": {
                template: 
                `<div layout="column" layout-fill>
                    <brd-header></brd-header>
                    <section layout="row" flex >
                        <brd-sidenav></brd-sidenav>
                        <md-content flex class="b-padding16">
                            <ui-view name="content"></ui-view>
                        </md-content>
                    </section>
                </div>`
            }
        }
    });
}
configureAppShell.$inject=["$stateProvider"];


// WEBPACK FOOTER //
// ./app/app-shell.route.ts